if (!customElements.get('dpc-product-tools')) {
  customElements.define('dpc-product-tools', class extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('section');
      this.form = document.getElementById(this.dataset.formId);
      this.mainButton = this.form?.querySelector('[name="add"]');
      this.bar = this.querySelector('[data-dpc-purchase-bar]');
      this.button = this.querySelector('[data-dpc-bar-button]');
      if (!this.section || !this.form || !this.mainButton || !this.bar || !this.button) return;
      this.variants = JSON.parse(this.querySelector('[data-dpc-purchase-variants]').textContent);
      this.price = this.querySelector('[data-dpc-bar-price]');
      this.variantTitle = this.querySelector('[data-dpc-bar-variant]');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.refresh();
        });
      };
      this.handleClick = () => {
        if (this.mode === 'options') {
          const options = this.section.querySelector('variant-radios, variant-selects') || this.mainButton;
          options.scrollIntoView({block:'center',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
          return;
        }
        if (this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true') return;
        this.form.requestSubmit(this.mainButton);
      };
      this.button.addEventListener('click', this.handleClick);
      this.section.addEventListener('change', this.schedule);
      window.addEventListener('scroll', this.schedule, {passive:true});
      window.addEventListener('resize', this.schedule, {passive:true});
      this.mobile.addEventListener('change', this.schedule);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.mainButton, {attributes:true,childList:true,subtree:true,characterData:true});
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (String(event.data.sectionId) === this.dataset.section) this.schedule();
        });
      }
      this.refresh();
    }

    refresh() {
      const variantId = this.form.querySelector('[name="id"]')?.value;
      const variant = this.variants.find((item) => String(item.id) === String(variantId));
      if (variant) {
        this.price.textContent = variant.price;
        this.variantTitle.textContent = variant.title.replaceAll(' / ', ' · ');
        this.updateAdvice(variant);
      }
      const rect = this.mainButton.getBoundingClientRect();
      const mainVisible = rect.bottom > 0 && rect.top < window.innerHeight;
      const visible = this.mobile.matches && !mainVisible;
      this.bar.hidden = !visible;
      document.body.classList.toggle('dpc-purchase-bar-visible', visible);
      this.mode = rect.top >= window.innerHeight ? 'options' : 'add';
      const busy = this.mainButton.getAttribute('aria-disabled') === 'true' || this.mainButton.classList.contains('loading');
      const unavailable = this.mainButton.disabled || !variant?.available;
      this.button.disabled = this.mode === 'add' && (unavailable || busy);
      this.button.textContent = this.mode === 'options'
        ? this.dataset.optionsLabel
        : busy ? this.dataset.busyLabel
        : unavailable ? (this.mainButton.querySelector('span')?.textContent.trim() || this.dataset.optionsLabel)
        : this.dataset.addLabel;
      if (this.mainButton.getAttribute('aria-haspopup')) this.button.setAttribute('aria-haspopup', this.mainButton.getAttribute('aria-haspopup'));
    }

    updateAdvice(variant) {
      const link = this.section.querySelector('[data-dpc-product-advice]');
      if (!link) return;
      const title = this.section.querySelector('h1')?.textContent.trim() || '';
      const productURL = new URL(this.form.closest('product-info')?.dataset.url || window.location.pathname, window.location.origin);
      productURL.searchParams.set('variant', variant.id);
      const message = `${this.dataset.adviceIntro} ${title}\n${variant.title}\n${variant.price}\n${productURL.href}`;
      const destination = new URL('https://wa.me/522211079395');
      destination.searchParams.set('text', message);
      link.href = destination.href;
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.unsubscribeVariant?.();
      this.button?.removeEventListener('click', this.handleClick);
      this.section?.removeEventListener('change', this.schedule);
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      this.mobile?.removeEventListener('change', this.schedule);
      document.body.classList.remove('dpc-purchase-bar-visible');
    }
  });
}

